import moment from 'moment';

const tripFullDateView = (dateString) => {
    return moment(dateString).format("DMMM YYYY");
    const gmtDate = moment.utc(dateString);
    const istDate = gmtDate.clone().add(5, 'hours').add(30, 'minutes');
    return istDate.format("DMMM YYYY");
};

const tripShortDateView = (dateString) => {
    return moment(dateString).format("DMMM");
    const gmtDate = moment.utc(dateString);
    const istDate = gmtDate.clone().add(5, 'hours').add(30, 'minutes');
    return istDate.format("DMMM");
}

const tripDateView = (dateString) => {
    return moment(dateString).format("hh:mm A, DMMM YYYY");
    const gmtDate = moment.utc(dateString);
    const istDate = gmtDate.clone().add(5, 'hours').add(30, 'minutes');
    return istDate.format("hh:mm A, DMMM YYYY");
}

const tripDurationFormat = (duration, unit = 'm') => {
    if (!duration || isNaN(duration)) return '-';

    let totalMinutes = duration;
    if (unit === 's') {
        totalMinutes = Math.floor(duration / 60);
    }

    if (totalMinutes === 0) return '0 minutes';

    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = Math.round(totalMinutes % 60);

    let result = '';

    if (days > 0) {
        result += `${days} day${days > 1 ? 's' : ''} `;
        result += `${hours} hour${hours !== 1 ? 's' : ''} `;
    } else if (hours > 0) {
        result += `${hours} hour${hours !== 1 ? 's' : ''} `;
    }

    if (minutes > 0 || days === 0) {
        result += `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }

    return result.trim()
};

const tripHoursFormat = (hours) => {
    if (!hours || isNaN(hours)) return '-';

    if (hours === 0) return '0 hours';

    const days = Math.floor(hours / 24);
    const remainingHours = Math.floor(hours % 24);
    const minutes = Math.round((hours % 1) * 60);

    let result = '';

    if (days > 0) {
        result += `${days} day${days > 1 ? 's' : ''} `;
        result += `${remainingHours} hour${remainingHours !== 1 ? 's' : ''} `;
    } else if (remainingHours > 0) {
        result += `${remainingHours} hour${remainingHours !== 1 ? 's' : ''} `;
    }

    if (minutes > 0 || (days === 0 && remainingHours === 0)) {
        result += `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }

    return result.trim();
};

export { tripDateView, tripDurationFormat, tripFullDateView, tripShortDateView, tripHoursFormat };

